import { render, staticRenderFns } from "./shorts.vue?vue&type=template&id=062521d6&"
import script from "./shorts.vue?vue&type=script&lang=js&"
export * from "./shorts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports